import React, { useEffect } from 'react';
import clsx from 'clsx';
import CampaignHeader from './components/CampaignHeader';
import CampaignEditingSection from './components/CampaignEditingSection';
import { useCampaignCard } from './hooks/useCampaignCard';

const CampaignCard = ({ 
	id,
	slug,
	title, 
	description, 
	status, 
	icon, 
	sequences = [],
	onUpdate,
	isUpdating = false
}) => {
	// Use the custom hook for campaign card logic
	const {
		isEditing,
		editingSequences,
		hasSaved,
		isDropdownOpen,
		statusConfig,
		hasSequences,
		canSave,
		MAX_SEQUENCES,
		setIsEditing,
		setEditingSequences,
		setHasSaved,
		setIsDropdownOpen,
		handleStartEditing,
		handleSave,
		handleCancel,
		handleSequenceUpdate,
		handleSequenceDelete,
		handleAddSequence,
		handleToggleStatus,
	} = useCampaignCard({ sequences, status, slug, onUpdate });



	// Reset editing state when update completes successfully
	useEffect(() => {
		// Only reset if we've saved and the update is complete
		if (!isUpdating && isEditing && hasSaved) {
			setIsEditing(false);
			setEditingSequences([]);
			setHasSaved(false);
		}
	}, [isUpdating, isEditing, hasSaved, setIsEditing, setEditingSequences, setHasSaved]);

	return (
		<div className={clsx(
			"rounded-lg border border-gray-200 relative",
			isUpdating && "opacity-75 pointer-events-none"
		)}
		style={{ zIndex: 1 }}>
			<CampaignHeader
				title={title}
				description={description}
				icon={icon}
				status={status}
				statusConfig={statusConfig}
				hasSequences={hasSequences}
				isEditing={isEditing}
				isUpdating={isUpdating}
				isDropdownOpen={isDropdownOpen}
				setIsDropdownOpen={setIsDropdownOpen}
				onStartEditing={handleStartEditing}
				onToggleStatus={handleToggleStatus}
				onCancel={handleCancel}
				onSave={handleSave}
				canSave={canSave}
			/>
			
			{isEditing && (
				<CampaignEditingSection
					editingSequences={editingSequences}
					campaignSlug={slug}
					maxSequences={MAX_SEQUENCES}
					onSequenceUpdate={handleSequenceUpdate}
					onSequenceDelete={handleSequenceDelete}
					onAddSequence={handleAddSequence}
				/>
			)}
		</div>
	);
};

export default CampaignCard;
